import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { ApplicationInsights, DistributedTracingModes, ITelemetryItem } from "@microsoft/applicationinsights-web";
import { setSessionStorageItem } from "../services/SessionStorageService";
import axios from "axios";
import { getEnvVar } from "../config/RuntimeConfig";

export const setupAppInsights = async (appId: string) => {
    const reactPlugin = new ReactPlugin();
    const connectionString = getEnvVar('APPLICATIONINSIGHTS_CONNECTION_STRING');
    const roleName = (getEnvVar('APPLICATIONINSIGHTS_ROLE_NAME') || '').replace('{appId}', appId);

    if (!connectionString || !roleName) {
        console.warn(
            'Application Insights is not configured. Connection string or role name is missing.'
        );
        return;
    }

    const appInsights = new ApplicationInsights({
        config: {
            connectionString,
            enableAutoRouteTracking: true,
            enableCorsCorrelation: true,
            excludeRequestFromAutoTrackingPatterns: [
                /api\.ipify\.org/
            ],
            distributedTracingMode: DistributedTracingModes.AI_AND_W3C,
            extensions: [reactPlugin],
        },
    });

    appInsights.loadAppInsights();

    // Set a custom session ID
    let sessionId = sessionStorage.getItem('x-session-id');
    if (!sessionId) {
        sessionId = window?.crypto?.randomUUID() ?? '';
    }

    if (sessionId) {
        appInsights.context.sessionManager.automaticSession.id = sessionId;
        setSessionStorageItem('x-session-id', sessionId, true); // this will dispatch the sesionStorageChangeEvent
        // axios.defaults.headers.common["x-session-id"] = sessionId;
    }

    appInsights.addTelemetryInitializer((env: ITelemetryItem) => {
        env.tags = env.tags || {};
        env.tags['ai.cloud.role'] = roleName;
    });
};

